export const FETCH_ERROR_TEXT = 'Помилка при завантаженні списку';
export const DELETE_ERROR_TEXT = 'Помилка при видаленні';
export const CREATE_ERROR_TEXT = 'Помилка при створенні';
export const EDIT_ERROR_TEXT = 'Помилка при редагуванні';
export const UPLOAD_FILE_ERROR = 'Сталася помилка при завантаженні фото';
